import {
  InputMaybe,
  MetricsV1FilterInput,
  MetricsV1MetricMetricTypeSpecInput,
  MetricsV1MetricNullHandlingConfigInput,
} from '@spotify/confidence-graphql';

import { MetricFormValues } from '../metricForms/types';
import { MetricType } from '../metricTypes';

export type {
  MetricFormValues,
  MetricMeasurementSource as MeasurementSource,
} from '../metricForms/types';

export type MetricDialogConfig = {
  enableGenerate?: boolean;
  minMetricsForGenerate?: number;
  validateForm?: (values: MetricFormValues) => string | undefined;
  transformBeforeSubmit?: (values: MetricFormValues) => MetricFormValues;
};

export enum StepId {
  // Measurement source selection (new vs existing)
  MeasurementSource = 'measurement-source',
  MeasurementSelector = 'measurement-selector',
  // Basic info
  About = 'about',
  Type = 'type',
  Inputs = 'inputs',
  // Type-specific measurement steps
  AverageMeasurement = 'average-measurement',
  RatioMeasurement = 'ratio-measurement',
  ConversionMeasurement = 'conversion-measurement',
  ConsumptionMeasurement = 'consumption-measurement',
  CtrMeasurement = 'ctr-measurement',
  QuantileMeasurement = 'quantile-measurement',
  PercentileLevel = 'percentile-level',
  // Aggregation and missing values (for measurement dialog)
  Aggregation = 'aggregation',
  MissingValues = 'missing-values',
  // Metric-specific steps
  TimeWindow = 'time-window',
  SuggestedUsage = 'suggested-usage',
  Summary = 'summary',
}

export type MeasurementFormValues = {
  // About step
  displayName: string;
  description?: string;
  owner: string;

  // Type step
  metricType: MetricType;

  // Inputs step
  entity: string;
  factTable: string;
  filter?: InputMaybe<MetricsV1FilterInput>;

  // Aggregation step (type-specific)
  typeSpec: MetricsV1MetricMetricTypeSpecInput;

  // Missing values step
  nullHandling?: MetricsV1MetricNullHandlingConfigInput;

  // Auto-derive tracking
  displayNameManuallyEdited?: boolean;

  // Additional fields
  labels?: Array<{ key: string; value: string }>;
};
